<div class="rs-review-ownership-structure" *ngIf="selectedOwnershipStructure">
  <div class="rs-review-step">{{ "review.ownership-structure" | translate }}</div>
  <div class="rs-review-ownership-structure__value">
    {{ selectedOwnershipStructure }}
  </div>
</div>
